/* RESPONSIBLE TEAM: team-reporting */
import ApplicationAdapter from 'embercom/adapters/application';
import { inject as service } from '@ember/service';

export default class ReportAdapter extends ApplicationAdapter {
  @service appService;

  urlForCreateRecord(modelName, snapShot) {
    return `${this.buildURL(modelName)}/update_report_and_charts`;
  }

  urlForUpdateRecord(modelName, snapShot) {
    return `${this.buildURL(modelName)}/update_report_and_charts`;
  }
  pathForType() {
    return 'reporting/custom_reports';
  }
}
